import {Alert, AlertDescription, AlertTitle} from '@/components/ui/alert';
import React from 'react';

export const Disclaimer = () => (
  <div>
    <Alert>
      <AlertTitle className="text-foreground font-bold mb-4">
        Translations
      </AlertTitle>
      <AlertDescription className="text-xs">
        THIS SERVICE MAY CONTAIN TRANSLATIONS POWERED BY GOOGLE. GOOGLE
        DISCLAIMS ALL WARRANTIES RELATED TO THE TRANSLATIONS, EXPRESS OR
        IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY, RELIABILITY, AND ANY
        IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
        AND NONINFRINGEMENT.
      </AlertDescription>
    </Alert>
  </div>
);
